import web from "../web";

class StatutsService {
    index(token){
        return web.get("/api/statuts", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/statuts", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/statuts/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/statuts/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/statuts/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new StatutsService()